import type { NestedResourceTabDropEdge } from './context';

/** Converts a native tab edge into the post-removal index used by our reorder handlers. */
export const getNestedResourceTabDropIndex = (
    resourceIds: string[],
    activeResourceId: string,
    targetResourceId: string,
    edge: NestedResourceTabDropEdge,
): number | undefined => {
    const sourceIndex = resourceIds.indexOf(activeResourceId);
    const targetIndex = resourceIds.indexOf(targetResourceId);

    if (sourceIndex < 0 || targetIndex < 0) {
        return undefined;
    }

    const insertionIndex = targetIndex + (edge === 'after' ? 1 : 0);

    return insertionIndex > sourceIndex ? insertionIndex - 1 : insertionIndex;
};
